import * as React from 'react'
import * as apiRoutes from './constants/ApiRoutes'

class Actions {
    static getApiRoutes() {
        return apiRoutes
    }
}

export { Actions }
